// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div style="position: absolute; display:flex; align-items: flex-end;">
    <div v-if="$store.state.showLocationButton" style="max-width: 300px; display:flex; align-items: flex-end;" class="loc">
      <v-btn class="tmenubt location"
             color="secondary"
             @click.stop.native="locationClicked()"
             >
        <v-icon class="hidden-sm-and-up">mdi-map-marker</v-icon>
        <span class="hidden-xs-only" style="color: #FFA751; font-family: Proxima_Bold"
              v-html="locationName()">
        </span></v-btn>
    </div>
    <v-spacer></v-spacer>

<div :class="{ mobileCss: appMobile }">
  <div style="display:flex;">
    <bottom-button :label="$t('Constellations')"
                v-if="$store.state.showConstellationsLinesButton !== false"
                   :fill-rule="'evenodd'"
                   :clip-rule="'evenodd'"
                   :d="icons.constellation"
                   :viewBox="'0 -4.7 50 60'"
                :toggled="$store.state.stel.constellations.lines_visible"
                @clicked="(b) => { $stel.core.constellations.lines_visible = b; $stel.core.constellations.labels_visible = b }">
    </bottom-button>
    <bottom-button :label="$t('Constellations Art')"
                v-if="$store.state.showConstellationsArtButton !== false"
                   :fill-rule="'evenodd'"
                   :clip-rule="'evenodd'"
                   :d="icons.constellationArt"
                   :viewBox="'0 -4.7 50 60'"
                   :toggled="$store.state.stel.constellations.images_visible"
                @clicked="(b) => { $stel.core.constellations.images_visible = b }">
    </bottom-button>
    <bottom-button :label="$t('Atmosphere')"
                v-if="$store.state.showAtmosphereButton !== false"
                   :fill-rule="'evenodd'"
                   :clip-rule="'evenodd'"
                   :d="icons.atmosphere"
                   :viewBox="'0 -4.7 50 60'"
                   :toggled="$store.state.stel.atmosphere.visible"
                @clicked="(b) => { $stel.core.atmosphere.visible = b }">
    </bottom-button>
    <bottom-button :label="$t('Landscape')"
                v-if="$store.state.showLandscapeButton !== false"
                   :fill-rule="'evenodd'"
                   :clip-rule="'evenodd'"
                   :d="icons.landScape"
                   :viewBox="'0 -4.7 50 60'"
                   :toggled="$store.state.stel.landscapes.visible"
                @clicked="(b) => { $stel.core.landscapes.visible = b }">
    </bottom-button>
    <bottom-button :label="$t('Azimuthal Grid')"
                v-if="$store.state.showAzimuthalGridButton !== false"
                   :fill-rule="'evenodd'"
                   :clip-rule="'evenodd'"
                   :d="icons.azimuthal"
                   :viewBox="'0 -4.7 50 60'"
                   :class="{mobile: mobileHide}"
                   :toggled="$store.state.stel.lines.azimuthal.visible"
                @clicked="(b) => { $stel.core.lines.azimuthal.visible = b }">
    </bottom-button>
    <bottom-button :label="$t('Equatorial Grid')"
                   :fill-rule="'evenodd'"
                   :clip-rule="'evenodd'"
                   :d="icons.equatorial"
                   :viewBox="'0 -4.7 50 60'"
                   :toggled="$store.state.stel.lines.equatorial.visible"
                   :class="{mobile: mobileHide}"
                @clicked="(b) => { $stel.core.lines.equatorial.visible = b }">
    </bottom-button>
  </div>
    <gyroscope-button
      class="bottom"
      :label="$t('Rotation')"
    ></gyroscope-button>
</div>
    <v-spacer></v-spacer>

    <v-menu v-if="$store.state.showTimeButtons" :close-on-content-click="false" transition="v-slide-y-transition" offset-y top left>
      <template v-slot:activator="{ on }">
        <v-btn large class="tmenubt time" color="secondary" v-on="on">
          <v-icon class="hidden-sm-and-up">mdi-clock-outline</v-icon>
          <span class="hidden-xs-only location-btn">
            <div class="text-subtitle-2" style="display:inline; color: #FFA751; margin-right: 5px;">{{ time }}</div>
            <div class="text-subtitle-2" style="display:inline">{{ date }}</div>
          </span>
        </v-btn>
      </template>
      <date-time-picker v-model="pickerDate" :value="time" :location="$store.state.currentLocation"></date-time-picker>
    </v-menu>

  </div>
</template>

<script>

import BottomButton from '@/components/bottom-button.vue'
import DateTimePicker from '@/components/date-time-picker.vue'
import swh from '@/assets/sw_helpers.js'
import Moment from 'moment'
import GyroscopeButton from '@/components/gyroscope-button.vue'

export default {
  components: { BottomButton, DateTimePicker, GyroscopeButton },
  data: function () {
    return {
      checkAppVersion: false,
      icons: {
        constellation: 'M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50ZM25 48C37.7026 48 48 37.7025 48 25C48 12.2974 37.7026 2 25 2C12.2974 2 2 12.2974 2 25C2 37.7025 12.2974 48 25 48ZM32.9203 13.041C33.4688 12.7509 33.9161 12.6733 34.1213 12.8786C34.3267 13.0839 34.249 13.5312 33.959 14.0797C35.7468 14.2321 37 14.5867 37 15C37 15.4133 35.7468 15.7679 33.959 15.9203C34.249 16.4687 34.3266 16.916 34.1213 17.1213C33.926 17.3166 33.5118 17.2559 33 17V33C33.5119 32.744 33.9261 32.6834 34.1213 32.8786C34.3267 33.0839 34.249 33.5312 33.959 34.0797C35.7468 34.2321 37 34.5867 37 35C37 35.4133 35.7468 35.7679 33.959 35.9203C34.249 36.4687 34.3266 36.916 34.1213 37.1213C33.916 37.3266 33.4687 37.249 32.9203 36.959C32.7679 38.7468 32.4133 40 32 40C31.5867 40 31.2321 38.7467 31.0797 36.9589C30.5313 37.2489 30.084 37.3265 29.8787 37.1213C29.6734 36.916 29.751 36.4687 30.041 35.9203C28.2532 35.7679 27 35.4133 27 35C27 34.7087 27.6224 34.4466 28.6158 34.2638L15.9374 27.2203C15.6993 27.2781 15.3393 27.1805 14.9203 26.959C14.7679 28.7468 14.4133 30 14 30C13.5867 30 13.2321 28.7467 13.0797 26.9589C12.5313 27.2489 12.084 27.3265 11.8787 27.1213C11.6734 26.916 11.751 26.4687 12.041 25.9203C10.2532 25.7679 9 25.4133 9 25C9 24.5867 10.2532 24.2321 12.041 24.0797C11.751 23.5312 11.6734 23.0839 11.8787 22.8787C12.084 22.6733 12.5313 22.751 13.0797 23.041C13.2321 21.2532 13.5867 20 14 20C14.4133 20 14.7679 21.2532 14.9203 23.041C15.3394 22.8193 15.6994 22.7218 15.9375 22.7796L28.6158 15.7362C27.6224 15.5534 27 15.2913 27 15C27 14.5867 28.2532 14.2321 30.041 14.0797C29.751 13.5312 29.6734 13.0839 29.8787 12.8787C30.084 12.6733 30.5313 12.751 31.0797 13.041C31.2321 11.2532 31.5867 10 32 10C32.4133 10 32.7679 11.2532 32.9203 13.041ZM30.0627 17.2203L17.3842 24.2638C18.3776 24.4466 19 24.7087 19 25C19 25.2913 18.3776 25.5534 17.3842 25.7362L30.0625 32.7797C30.2854 32.7255 30.6151 32.8075 31 33V16.9999C30.6152 17.1923 30.2855 17.2744 30.0627 17.2203Z',
        constellationArt: 'M50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25ZM48 25C48 37.7025 37.7026 48 25 48C12.2974 48 2 37.7025 2 25C2 12.2974 12.2974 2 25 2C37.7026 2 48 12.2974 48 25ZM25 15.124C23.6353 12.6646 21.012 11 18 11C15.2706 11 12.8604 12.3668 11.4167 14.4534C11.2899 14.1623 11.1487 14 11 14C10.5867 14 10.2321 15.2532 10.0797 17.041C9.53131 16.751 9.08398 16.6733 8.87866 16.8787C8.6734 17.0839 8.75098 17.5312 9.04102 18.0797C7.25323 18.2321 6 18.5867 6 19C6 19.4133 7.25323 19.7679 9.04102 19.9203C8.75104 20.4687 8.6734 20.916 8.87872 21.1213C9.08398 21.3265 9.53131 21.2489 10.0797 20.9589C10.2321 22.7467 10.5867 24 11 24C11.4133 24 11.7679 22.7468 11.9203 20.959C12.4687 21.249 12.916 21.3266 13.1213 21.1213C13.3266 20.916 13.249 20.4687 12.959 19.9203C14.7468 19.7679 16 19.4133 16 19C16 18.5867 14.7468 18.2321 12.959 18.0797C13.249 17.5312 13.3267 17.0839 13.1213 16.8786C12.9807 16.7379 12.7262 16.7301 12.4034 16.8325C13.2725 14.59 15.4506 13 18 13C21.3137 13 24 15.6863 24 19V35C23.4882 34.7441 23.074 34.6833 22.8787 34.8787C22.6734 35.0839 22.751 35.5312 23.041 36.0797C21.2532 36.2321 20 36.5867 20 37C20 37.4133 21.2532 37.7679 23.041 37.9203C22.751 38.4687 22.6734 38.916 22.8787 39.1213C23.084 39.3265 23.5313 39.2489 24.0797 38.9589C24.2321 40.7467 24.5867 42 25 42C25.4133 42 25.7679 40.7468 25.9203 38.959C26.4687 39.249 26.916 39.3266 27.1213 39.1213C27.3266 38.916 27.249 38.4687 26.959 37.9203C28.7468 37.7679 30 37.4133 30 37C30 36.5867 28.7468 36.2321 26.959 36.0797C27.249 35.5312 27.3267 35.0839 27.1213 34.8786C26.9261 34.6833 26.5119 34.744 26 34.9999V19C26 15.6863 28.6863 13 32 13C34.5494 13 36.7275 14.59 37.5966 16.8325C37.2738 16.7301 37.0194 16.7379 36.8787 16.8787C36.6734 17.0839 36.751 17.5312 37.041 18.0797C35.2532 18.2321 34 18.5867 34 19C34 19.4133 35.2532 19.7679 37.041 19.9203C36.751 20.4687 36.6734 20.916 36.8787 21.1213C37.084 21.3265 37.5313 21.2489 38.0797 20.9589C38.2321 22.7467 38.5867 24 39 24C39.4133 24 39.7679 22.7468 39.9203 20.959C40.4687 21.249 40.916 21.3266 41.1213 21.1213C41.3266 20.916 41.249 20.4687 40.959 19.9203C42.7468 19.7679 44 19.4133 44 19C44 18.5867 42.7468 18.2321 40.959 18.0797C41.249 17.5312 41.3267 17.0839 41.1213 16.8786C40.9161 16.6733 40.4688 16.7509 39.9203 17.041C39.7679 15.2532 39.4133 14 39 14C38.8513 14 38.7101 14.1623 38.5833 14.4534C37.1396 12.3668 34.7294 11 32 11C28.988 11 26.3647 12.6646 25 15.124Z',
        atmosphere: 'M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50ZM25 48C34.2527 48 42.2292 42.5364 45.8795 34.6594C44.8646 33.877 43.6567 33.333 42.3397 33.1113L41.4008 32.9534L40.9315 32.125C38.1801 27.2694 32.9706 24 27 24C21.4246 24 16.5139 26.8501 13.6467 31.1823L12.7032 32.6077L11.1482 31.8977C9.88702 31.3219 8.48383 31 7 31C5.58856 31 4.24548 31.2924 3.02795 31.8199C5.93396 41.1926 14.672 48 25 48ZM42.6716 31.139C44.133 31.3849 45.4868 31.9479 46.6599 32.7548C47.5275 30.3319 48 27.7212 48 25C48 12.2975 37.7026 2 25 2C12.2974 2 2 12.2975 2 25C2 26.6695 2.17786 28.2974 2.51569 29.8659C3.90106 29.3074 5.41467 29 7 29C8.77618 29 10.4622 29.3859 11.9789 30.0784C15.2007 25.2104 20.7254 22 27 22C33.7198 22 39.5796 25.6823 42.6716 31.139ZM32.9203 11.041C33.4688 10.7509 33.9161 10.6733 34.1213 10.8786C34.3267 11.0839 34.249 11.5312 33.959 12.0797C35.7468 12.2321 37 12.5867 37 13C37 13.4133 35.7468 13.7679 33.959 13.9203C34.249 14.4687 34.3266 14.916 34.1213 15.1213C33.916 15.3266 33.4687 15.249 32.9203 14.959C32.7679 16.7468 32.4133 18 32 18C31.5867 18 31.2321 16.7467 31.0797 14.9589C30.5313 15.2489 30.084 15.3265 29.8787 15.1213C29.6734 14.916 29.751 14.4687 30.041 13.9203C28.2532 13.7679 27 13.4133 27 13C27 12.5867 28.2532 12.2321 30.041 12.0797C29.751 11.5312 29.6734 11.0839 29.8787 10.8787C30.084 10.6733 30.5313 10.751 31.0797 11.041C31.2321 9.25323 31.5867 8 32 8C32.4133 8 32.7679 9.25317 32.9203 11.041Z',
        landScape: 'M48.6386 33.1582C45.2566 42.9595 35.9505 50 25 50C14.2132 50 5.02198 43.1684 1.51699 33.5958C1.32789 33.0794 1.15535 32.555 0.999992 32.0232C0.34908 29.7952 0 27.4383 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 27.142 49.7306 29.221 49.2239 31.2051L49.2129 31.2479C49.0464 31.8952 48.8546 32.5323 48.6386 33.1582ZM46.8315 32.2575C43.7925 41.4037 35.1666 48 25 48C14.9865 48 6.46756 41.6009 3.30952 32.6689C9.09949 29.7973 16.8765 28 25.5 28C33.7041 28 41.1419 29.6267 46.8315 32.2575ZM32 26.3367C29.8949 26.1157 27.722 26 25.5 26C22.9243 26 20.4146 26.1554 18 26.4502V21.917C20.8377 21.441 23 18.973 23 16C23 12.6863 20.3137 10 17 10C13.6863 10 11 12.6863 11 16C11 18.973 13.1623 21.441 16 21.917V26.7294C11.0214 27.5131 6.503 28.8973 2.71963 30.7307C2.24982 28.8987 2 26.9785 2 25C2 12.2975 12.2975 2 25 2C37.7025 2 48 12.2975 48 25C48 26.8279 47.7868 28.606 47.3838 30.3108C43.5316 28.5682 38.9818 27.2761 34 26.581V21.874C35.7252 21.4299 37 19.8638 37 18C37 15.7909 35.2091 14 33 14C30.7909 14 29 15.7909 29 18C29 19.8638 30.2748 21.4299 32 21.874V26.3367ZM33 20C34.1046 20 35 19.1046 35 18C35 16.8954 34.1046 16 33 16C31.8954 16 31 16.8954 31 18C31 19.1046 31.8954 20 33 20ZM21 16C21 18.2091 19.2091 20 17 20C14.7909 20 13 18.2091 13 16C13 13.7909 14.7909 12 17 12C19.2091 12 21 13.7909 21 16Z',
        azimuthal: 'M50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25ZM13.7098 34.8761L8.04473 40.5411C4.5009 36.6768 2.2608 31.5975 2.02135 26H10.0328C10.2559 29.3898 11.6051 32.472 13.7098 34.8761ZM15.124 36.2903L9.45895 41.9553C13.3232 45.4991 18.4025 47.7392 24 47.9787V39.9672C20.6102 39.7441 17.5281 38.3949 15.124 36.2903ZM24 37.9621C21.1619 37.7462 18.5785 36.619 16.5418 34.8724L24 27.4142V37.9621ZM26 39.9672V47.9787C31.5975 47.7392 36.6768 45.4991 40.541 41.9553L34.876 36.2903C32.4719 38.3949 29.3898 39.7441 26 39.9672ZM33.4582 34.8724C31.4215 36.619 28.8381 37.7462 26 37.9621V27.4142L33.4582 34.8724ZM36.2902 34.8761L41.9553 40.5411C45.4991 36.6768 47.7392 31.5975 47.9787 26H39.9672C39.7441 29.3898 38.3949 32.472 36.2902 34.8761ZM37.9621 26C37.7462 28.8381 36.619 31.4215 34.8724 33.4582L27.4142 26H37.9621ZM39.9672 24H47.9787C47.7392 18.4025 45.4991 13.3232 41.9553 9.45895L36.2903 15.124C38.3949 17.5281 39.7441 20.6102 39.9672 24ZM34.8724 16.5418C36.619 18.5785 37.7462 21.1619 37.9621 24H27.4142L34.8724 16.5418ZM34.8761 13.7098L40.5411 8.04474C36.6769 4.5009 31.5975 2.26081 26 2.02135V10.0328C29.3898 10.2559 32.472 11.6051 34.8761 13.7098ZM26 12.0379C28.8381 12.2538 31.4215 13.381 33.4582 15.1276L26 22.5858V12.0379ZM24 10.0328V2.02135C18.4025 2.26081 13.3231 4.5009 9.45892 8.04474L15.1239 13.7098C17.528 11.6051 20.6102 10.2559 24 10.0328ZM16.5418 15.1276C18.5785 13.381 21.1619 12.2538 24 12.0379V22.5858L16.5418 15.1276ZM13.7097 15.124C11.6051 17.5281 10.2559 20.6102 10.0328 24H2.02135C2.26081 18.4025 4.50089 13.3232 8.04471 9.45895L13.7097 15.124ZM15.1276 16.5418L22.5858 24H12.0379C12.2538 21.1619 13.381 18.5785 15.1276 16.5418ZM12.0379 26H22.5858L15.1276 33.4582C13.381 31.4215 12.2538 28.8381 12.0379 26Z',
        equatorial: 'M50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25ZM32.3459 3.19812C37.1139 4.80396 41.1828 7.93005 43.9763 12H37.8151C36.4765 8.34253 34.5901 5.30298 32.3459 3.19812ZM47.9786 24C47.8241 20.3885 46.8369 16.9928 45.204 14H38.4738C39.3683 17.0377 39.9038 20.4222 39.9882 24H47.9786ZM33.8916 8.35132C34.5529 9.45337 35.1519 10.6758 35.6753 12H26V2.07129C28.8312 2.4751 31.635 4.59033 33.8916 8.35132ZM36.3831 14H26V24H37.9877C37.8978 20.3708 37.3216 16.9805 36.3831 14ZM24 2.07129V12H14.3247C14.8481 10.6758 15.4471 9.45337 16.1084 8.35132C18.365 4.59033 21.1688 2.4751 24 2.07129ZM24 14H13.6169C12.6784 16.9805 12.1022 20.3708 12.0123 24H24V14ZM17.6541 3.19812C15.4099 5.30298 13.5235 8.34253 12.1849 12H6.02368C8.8172 7.93005 12.8861 4.80396 17.6541 3.19812ZM11.5262 14H4.79602C3.16315 16.9928 2.17584 20.3885 2.02136 24H10.0118C10.0962 20.4222 10.6317 17.0377 11.5262 14ZM10.0118 26H2.02136C2.17584 29.6115 3.16315 33.0072 4.79602 36H11.5262C10.6317 32.9623 10.0962 29.5778 10.0118 26ZM12.1849 38H6.02368C8.8172 42.0699 12.8861 45.196 17.6541 46.8019C15.4099 44.697 13.5235 41.6575 12.1849 38ZM14.3247 38H24V47.9287C21.1688 47.5249 18.365 45.4097 16.1084 41.6487C15.4471 40.5466 14.8481 39.3242 14.3247 38ZM24 36H13.6169C12.6784 33.0195 12.1022 29.6292 12.0123 26H24V36ZM26 38V47.9287C28.8312 47.5249 31.635 45.4097 33.8916 41.6487C34.5529 40.5466 35.1519 39.3242 35.6753 38H26ZM36.3831 36H26V26H37.9877C37.8978 29.6292 37.3216 33.0195 36.3831 36ZM38.4738 36C39.3683 32.9623 39.9038 29.5778 39.9882 26H47.9786C47.8241 29.6115 46.8369 33.0072 45.204 36H38.4738ZM37.8151 38H43.9763C41.1827 42.0699 37.1138 45.196 32.3459 46.8019C34.5901 44.697 36.4765 41.6575 37.8151 38Z'
        // mobileOne: 'M275.23 490.73c-85.812-28.895-145-108.48-147.28-199.91-0.078124-3.0469-2.5078-5.4961-5.5586-5.4961h-15.418c-3.1367 0-5.7227 2.5898-5.6484 5.7266 2.4297 104.81 71.441 195.88 170.94 226.75 1.3047 0.40625 2.1289 1.6836 1.9297 3.0352l-2.8086 19.242c-0.3125 2.1328 1.8047 3.8047 3.8047 3.0078l64.98-25.852c2.0039-0.79688 2.3906-3.4609 0.69922-4.7969l-54.875-43.355c-1.6914-1.3359-4.1953-0.33984-4.5078 1.793l-2.5664 17.578c-0.25 1.7266-2.0312 2.8359-3.6914 2.2773z',
        // mobileArrowOne: 'm425.81 39.168 2.8086-19.242c0.3125-2.1328-1.8047-3.8047-3.8047-3.0078l-64.984 25.855c-2.0039 0.79687-2.3906 3.4609-0.69922 4.7969l54.875 43.355c1.6914 1.3359 4.1953 0.33984 4.5078-1.793l2.5664-17.578c0.25391-1.7344 2.0352-2.8398 3.6953-2.2812 85.812 28.895 145 108.48 147.28 199.91 0.078124 3.0469 2.5078 5.4961 5.5586 5.4961h15.418c3.1367 0 5.7227-2.5898 5.6484-5.7266-2.4297-104.8-71.441-195.87-170.94-226.75-1.3086-0.40234-2.1289-1.6836-1.9297-3.0352z',
        // mobileArrowTwo: 'm244.09 54.148-119.95 119.95c-16.527 16.527-16.527 43.414 0 59.938l271.82 271.82c16.523 16.523 43.41 16.523 59.938 0l119.95-119.95c16.527-16.527 16.527-43.414 0.003907-59.938l-271.82-271.83c-16.523-16.527-43.414-16.527-59.941 0.003907zm-58.984 86.246c-1.5312-1.5312-1.5312-4.0234 0-5.5508l19.738-19.738c1.5312-1.5312 4.0234-1.5312 5.5508 0l0.46094 0.46094c1.5312 1.5312 1.5312 4.0195 0 5.5508l-19.738 19.738c-1.5312 1.5312-4.0234 1.5312-5.5508 0zm338.28 274.68-38.309 38.309c-3.0977 3.0977-8.1641 3.0977-11.258 0-3.0977-3.0977-3.0977-8.1641 0-11.258l38.309-38.309c3.0977-3.0977 8.1641-3.0977 11.258 0 3.0977 3.0938 3.0977 8.1641 0 11.258zm37.625-91.188c2.0781 2.0781 2.0781 5.4492 0 7.5273l-159.59 159.59c-2.0781 2.0781-5.4492 2.0781-7.5273 0l-263.25-263.25c-2.0781-2.0781-2.0781-5.4492 0-7.5273l159.59-159.6c2.0781-2.0781 5.4492-2.0781 7.5273 0z'
      },
      mobileHide: true
    }
  },
  computed: {
    appVersion: function () {
      var version = swh.checkAppVersion()
      if (version) {
        return true
      } else {
        return false
      }
    },
    appMobile: function () {
      var app = swh.checkApp()
      if (app) {
        return true
      } else {
        return false
      }
    },
    time: {
      get: function () {
        return this.getLocalTime().format('HH:mm:ss')
      }
    },
    date: {
      get: function () {
        return this.getLocalTime().format('YYYY-MM-DD')
      }
    },
    fullscreenBtnImage: function () {
      return this.$store.state.fullscreen ? require('@/assets/images/svg/ui/fullscreen_exit.svg') : require('@/assets/images/svg/ui/fullscreen.svg')
    },
    pickerDate: {
      get: function () {
        const t = this.getLocalTime()
        t.milliseconds(0)
        return t.format()
      },
      set: function (v) {
        const m = Moment(v)
        m.local()
        m.milliseconds(this.getLocalTime().milliseconds())
        this.$stel.core.observer.utc = m.toDate().getMJD()
      }
    }
  },
  methods: {
    // The MomentJS time in local time
    getLocalTime: function () {
      var d = new Date()
      d.setMJD(this.$store.state.stel.observer.utc)
      const m = Moment(d)
      m.local()
      return m
    },
    locationClicked: function () {
      this.$store.commit('toggleBool', 'showLocationDialog')
    },
    setFullscreen: function (b) {
      this.$fullscreen.toggle(document.body, {
        wrap: false,
        callback: this.onFullscreenChange
      })
    },
    setNightMode: function (b) {
      this.$store.commit('toggleBool', 'nightmode')
      if (window.navigator.userAgent.indexOf('Edge') > -1) {
        document.getElementById('nightmode').style.opacity = b ? '0.5' : '0'
      }
      document.getElementById('nightmode').style.visibility = b ? 'visible' : 'hidden'
    },
    onFullscreenChange: function (b) {
      if (this.$store.state.fullscreen === b) return
      this.$store.commit('toggleBool', 'fullscreen')
    },
    locationName: function () {
      if (typeof this.$store.state.currentLocation.short_name !== 'undefined') {
        return this.$store.state.currentLocation.short_name
      } else {
        return '<span>Undefined</span>'
      }
    }
  }
}
</script>

<style>
@media all and (max-width: 600px) {
  .tmenubt {
    min-width: 30px;
  }
}
@media all and (min-width: 600px) {
  .tbtcontainer {
    width: 300px;
  }
}
</style>
<style lang="scss" scoped>
  .location-btn{
    .text-subtitle-2{
      font-size: 16px !important;
      font-family: Proxima_Bold !important;
      @media screen and (max-width: 699px) and (min-width: 600px){
        font-size: 12px !important;
      }
    }
  }
  .bottom-button{
    &.mobile{
      @media all and (max-width: 599px){
        display: none !important;
      }
    }
  }
  .gyroscopeEnabled{
    display:none;
  }
  .mobileCss{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    .gyroscope-container{
      width: 45px;
      a{
        display: flex;
        align-items: flex-end;
        width: 70px;
      }
    }
  }
  @media (orientation: landscape) and (max-width:499px){
    .mobileCss{
      flex-direction: row;
    }
    .bottom-button{
      width: 50px;
      height: 50px;
      svg{
        width: 50px;
        height: 55px;
      }
    }
    .btm-bar{
      bottom: 20px !important;
      padding: 0 25px !important;
    }
  }
</style>
